//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "ReferalHeadingBlock",

  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },

  computed: {
    headItems: function () {
      return (this.values?.tabs || []).map((t, i) => {

        return {
          value: i,
          name: t?.title,
        }
      })
    },
    section: function () {
      return (this.values?.tabs || [])?.[this.activeIndex] || {}
    },
  },

  methods: {
    changeSection: function (idx) {
      this.$emit('changeSection', idx);
    }
  }
})
